import React from 'react';
import JobDetailView from '../components/JobDetailView';

const JobDetailPage: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
      <div className="px-4 py-6 sm:px-0">
        <JobDetailView />
      </div>
    </div>
  );
};

export default JobDetailPage;
